export enum EquipmentCheckStatus {
	PENDING = 'pending',
	SUCCESS = 'success',
	FAILURE = 'failure'
}
